export enum StripeAccountStatusCode{
    Unknown = 0,
    Pending = 1,
    Inactive = 2,
    Active = 3
}